import { useFormContext, UseFormReturn } from 'react-hook-form';

import { AppError } from '@/utils';

import { EditUserForm } from '.';

export const useEditUserFormContext = ():
  | UseFormReturn<EditUserForm>
  | never => {
  const form = useFormContext<EditUserForm>();

  if (form === null)
    throw AppError.hookScopeError(
      'useEditUserFormContext can only be used inside a Edit User Form Context Provider.',
    );

  return form;
};
